import * as yup from "yup";

export const schema = yup.object().shape({
    name: yup.string().required().min(3).max(150),
    description: yup
        .string()
        .transform((value) => (!value ? undefined : value))
        .min(3)
        .max(1000),
    category_id: yup.number().required().moreThan(0)
});